import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { modalClear } from "../../_actions";
import _ from "lodash";
import "./index.css";

class AlertModal extends Component {
  handleClose = () => {
    this.props.modalClear();
  };

  renderErrorDetails = (key, value) => {
    return (
      <div>
        <br />
        <span>{key} : </span>
        <span>{value}</span>
      </div>
    );
  };

  processErrorDetails = () => {
    const { alert } = this.props;
    if (!alert.message) {
      return null;
    }

    const errorList = [];
    _.forOwn(alert.message.errorDetails, (value, key) => {
      return errorList.push(this.renderErrorDetails(key, value));
    });

    return errorList;
  };

  render() {
    const { alert } = this.props;

    let modalTitle = "Error";
    let modalTxt = null;

    if (alert.message && alert.message.status && alert.message.statusText) {
      modalTitle = alert.message.status + " - " + alert.message.statusText;
      modalTxt = alert.message.errorMsg ? alert.message.errorMsg : null;
    }

    if (typeof alert.message === "string") {
      modalTxt = alert.message;
    }

    return (
      <div className="modal-container">
        <Modal className="modal-alert" show={alert.message !== undefined} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalTxt ? modalTxt : null}
            {this.processErrorDetails()}
            <br />
            If you require immediate assistance, please feel free to contact the development team at&nbsp;
            <a href="mailto:cypinfrastructure@wspdigital.com">cypinfrastructure@wspdigital.com</a>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { user } = state.authentication;
  return {
    alert,
    user
  };
}

export default connect(
  mapStateToProps,
  {
    modalClear
  }
)(AlertModal);



// WEBPACK FOOTER //
// ./src/_components/AlertModal/index.js